import { globalStyles } from "@client/shared/constants";
const { background, display, flex } = globalStyles;

const styles = {
  trialIndicator: {
    ...display.flex,
    ...flex.align.center,
    ...flex.justify.around,
    paddingLeft: 2,
    paddingRight: 2,
    padding: 1,
    marginRight: 5,
    border: `1px solid`,
    borderColor: "primary.main",
    borderRadius: 5,
  },
};

export default styles;
